"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeActiveDelivery = void 0;
var BasketUpdatedEvent = _interopRequireWildcard(require("@ori-events/basket-updated"));
var UpdateDeliveryEvent = _interopRequireWildcard(require("@ori-events/update-delivery"));
var UpdateDeliveryChannelEvent = _interopRequireWildcard(require("@ori-events/update-delivery-channel"));
var UpdateDeliveryChannelFailedEvent = _interopRequireWildcard(require("@ori-events/update-delivery-channel-failed"));
var UpdateDeliveryFailedEvent = _interopRequireWildcard(require("@ori-events/update-delivery-failed"));
var _logger = require("../logger");
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function (e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
    return f;
  })(e, t);
}
const changeActiveDelivery = async params => new Promise((resolve, reject) => {
  const {
    addressId,
    deliveryChannelId,
    force = false,
    isAddressSelected,
    isChannelSelected,
    registrationId,
    setIsDeliveryChanged
  } = params;
  const willUpdateAddress = deliveryChannelId !== undefined && addressId !== undefined && (force || !isAddressSelected);
  const willUpdateDeliveryChannel = deliveryChannelId !== undefined && (force || !isChannelSelected);
  (0, _logger.logDebug)('changeActiveDelivery() called, params:', {
    willUpdateAddress,
    willUpdateDeliveryChannel,
    ...params
  });
  function removeEventListeners() {
    window.removeEventListener(BasketUpdatedEvent.Name, handleResolve);
    window.removeEventListener(UpdateDeliveryFailedEvent.Name, handleReject);
    window.removeEventListener(UpdateDeliveryChannelFailedEvent.Name, handleReject);
  }
  function handleResolve() {
    removeEventListeners();
    setIsDeliveryChanged?.(true);
    resolve();
  }
  function handleReject(event) {
    removeEventListeners();
    reject(event.detail.localizedMessage);
  }
  if (!willUpdateAddress && !willUpdateDeliveryChannel) {
    handleResolve();
    return;
  }
  window.addEventListener(BasketUpdatedEvent.Name, handleResolve);
  window.addEventListener(UpdateDeliveryFailedEvent.Name, handleReject);
  window.addEventListener(UpdateDeliveryChannelFailedEvent.Name, handleReject);
  if (willUpdateAddress) {
    const updateDeliveryEvent = new CustomEvent(UpdateDeliveryEvent.Name, {
      detail: {
        deliveryAddressId: addressId,
        deliveryChannelId,
        ...(Boolean(registrationId) && {
          registrationId: String(registrationId)
        })
      }
    });
    (0, _logger.logDebug)('Triggering event', updateDeliveryEvent);
    window.dispatchEvent(updateDeliveryEvent);
  } else {
    const updateDeliveryChannelEvent = new CustomEvent(UpdateDeliveryChannelEvent.Name, {
      detail: {
        deliveryChannelId
      }
    });
    (0, _logger.logDebug)('Triggering event', updateDeliveryChannelEvent);
    window.dispatchEvent(updateDeliveryChannelEvent);
  }
});
exports.changeActiveDelivery = changeActiveDelivery;